import ReactECharts from "echarts-for-react";

export default function ChartLead({ chartData }) {
  const mo = chartData?.mo ?? [];
  const tls = chartData?.tls ?? [];
  const sales = chartData?.sales ?? [];
  const leadSource = chartData?.leadSource ?? [];
  const organizationType = chartData?.organizationType ?? [];
  const statusLead = chartData?.statusLead ?? [];
  const spkStatus = chartData?.spkStatus ?? [];

  const monthlyLeads = [
    { month: "Jan", total: 120 },
    { month: "Feb", total: 180 },
    { month: "Mar", total: 150 },
    { month: "Apr", total: 200 },
    { month: "Mei", total: 170 },
    { month: "Jun", total: 210 },
    { month: "Jul", total: 190 },
  ];

  const statusLeads = [
    { name: "New", value: 320 },
    { name: "Follow-up", value: 240 },
    { name: "Closed", value: 140 },
    { name: "Lost", value: 60 },
  ];

  const sourceLeads = [
    { name: "Website", value: 300 },
    { name: "Ads", value: 220 },
    { name: "Referral", value: 180 },
    { name: "Offline", value: 90 },
  ];

  const topProducts = [
    { name: "Yoyic Blueberry", value: 3946 },
    { name: "Pocky", value: 2998 },
    { name: "Golda Coffee", value: 2758 },
    { name: "Nyam-nyam", value: 2774 },
    { name: "Lottee Chocopie", value: 2647 },
    { name: "Lifebuoy Cair 900 Ml", value: 2353 },
    { name: "Beng beng", value: 2322 },
    { name: "Oreo Wafer Sandwich", value: 2203 },
    { name: "Tipe X Joyko", value: 1857 },
    { name: "Pepsodent 120 gr", value: 1603 },
  ];

  const optionMonthly = {
    title: { text: "Jumlah Leads MO", left: "center" },
    tooltip: { trigger: "axis" },
    grid: { top: 50, bottom: 50, left: 60, right: 30 },
    xAxis: {
      type: "category",
      data: mo.map((d) => d.mo),
      axisLabel: {
        interval: 0,
        formatter: function (value) {
          return value.length > 7 ? value.slice(0, 7) + "..." : value;
        },
      },
    },
    yAxis: { type: "value" },
    series: [
      {
        type: "bar",
        data: mo.map((d) => d.total),
        itemStyle: {
          color: (params) => {
            const colors = [
              "#ef4444",
              "#f59e0b",
              "#22c55e",
              "#3b82f6",
              "#a855f7",
            ];
            return colors[params.dataIndex % colors.length];
          },
          borderRadius: [6, 6, 0, 0],
        },
      },
    ],
  };

  const raw = (leadSource || []).map((d) => ({
    name: String(d.lead_source || d.name || ""),
    value: Number(d.value) || 0,
  }));
  raw.sort((a, b) => b.value - a.value);

  const TOP = 6;
  const topData = raw.slice(0, TOP);
  const others = raw.slice(TOP);
  if (others.length) {
    const sumOthers = others.reduce((s, x) => s + x.value, 0);
    if (sumOthers > 0) topData.push({ name: "Lainnya", value: sumOthers });
  }

  const optionStatus = {
    title: { text: "Status Leads", left: "center", top: 6 },
    tooltip: {
      trigger: "item",
      formatter: ({ name, value, percent }) =>
        `${name}<br/>${value} (${percent}%)`,
    },
    legend: { type: "scroll", orient: "vertical", right: 0, top: "middle" },
    series: [
      {
        type: "pie",
        radius: ["42%", "72%"],
        center: ["42%", "48%"],
        avoidLabelOverlap: false,
        minShowLabelAngle: 0,
        labelLayout: { hideOverlap: false, moveOverlap: "shiftY" },
        label: {
          show: true,
          position: "outside",
          alignTo: "labelLine",
          distanceToLabelLine: 4,
          width: 120,
          overflow: "truncate",
          formatter: ({ name, percent }) => {
            const n = name?.length > 18 ? name.slice(0, 18) + "…" : name;
            return `${n}\n${Math.round(percent)}%`;
          },
          fontSize: 12,
          fontWeight: "bold",
          color: "#111",
        },
        labelLine: { show: true, length: 10, length2: 8 },
        itemStyle: { borderRadius: 6, borderColor: "#fff", borderWidth: 2 },
        data: statusLead,
        color: [
          "#3b82f6",
          "#f59e0b",
          "#22c55e",
          "#ef4444",
          "#a855f7",
          "#06b6d4",
          "#84cc16",
        ],
      },
    ],
  };

  const optionSource = {
    title: { text: "Sumber Leads", left: "center" },
    tooltip: { trigger: "item" },
    legend: { bottom: 0 },
    series: [
      {
        type: "pie",
        radius: ["40%", "70%"],
        label: { show: true, formatter: "{b}\n{d}%" },
        data: (organizationType || []).map((d) => ({
          name: d.organization_type,
          value: Number(d.value) || 0,
        })),
      },
    ],
  };

  const optionTopProducts = {
    title: {
      text: "Jumlah Lead Sales",
      left: "center",
      top: 10,
      textStyle: {
        fontSize: 16,
        fontWeight: "bold",
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: "{b}: {c}",
    },
    grid: {
      left: "25%",
      right: "10%",
      bottom: "5%",
      top: "15%",
    },
    xAxis: {
      type: "value",
      axisLabel: { color: "#555" },
    },
    yAxis: {
      type: "category",
      data: sales.map((p) => p.sales),
      axisLabel: {
        color: "#555",
        fontSize: 12,
        formatter: function (value) {
          return value.length > 7 ? value.slice(0, 7) + "..." : value;
        },
      },
      inverse: true,
    },
    series: [
      {
        type: "bar",
        data: sales.map((v) => v.total),
        barWidth: 30,
        itemStyle: {
          borderRadius: [0, 6, 6, 0],
          color: function (params) {
            const colors = [
              "#4f46e5",
              "#22c55e",
              "#ef4444",
              "#f59e0b",
              "#06b6d4",
              "#ec4899",
              "#8b5cf6",
              "#10b981",
              "#f97316",
              "#3b82f6",
            ];
            return colors[params.dataIndex % colors.length];
          },
        },
        label: {
          show: true,
          position: "right",
          color: "#333",
          fontWeight: "bold",
        },
      },
    ],
  };

  const optionLineChart = {
    title: {
      text: "Proses Leads",
      left: "center",
      top: 10,
      textStyle: {
        fontSize: 16,
        fontWeight: "bold",
      },
    },
    tooltip: {
      trigger: "axis",
    },
    grid: {
      left: "10%",
      right: "5%",
      bottom: "10%",
      top: "20%",
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: spkStatus.map((val) => val.spk_status),
      axisLine: { lineStyle: { color: "#888" } },
      axisLabel: { color: "#555" },
    },
    yAxis: {
      type: "value",
      axisLine: { lineStyle: { color: "#888" } },
      axisLabel: { color: "#555" },
      splitLine: { lineStyle: { color: "#eee" } },
    },
    series: [
      {
        name: "Jumlah Leads",
        type: "line",
        smooth: true,
        data: spkStatus.map((val) => val.total),
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: "#4f46e5",
        },
        lineStyle: {
          width: 3,
          color: "#4f46e5",
        },
        areaStyle: {
          color: "rgba(79, 70, 229, 0.2)",
        },
        emphasis: {
          focus: "series",
        },
      },
    ],
  };

  const optionNightingale = {
    title: { text: "Jumlah Leads TLS", left: "center" },
    tooltip: { trigger: "axis" },
    grid: { top: 50, bottom: 50, left: 60, right: 30 },
    xAxis: {
      type: "category",
      data: tls.map((d) => d.tls),
      axisLabel: {
        interval: 0,
        rotate: 30,
        formatter: function (value) {
          return value.length > 7 ? value.slice(0, 7) + "..." : value;
        },
      },
    },
    yAxis: { type: "value" },
    series: [
      {
        type: "bar",
        data: tls.map((d) => d.total),
        itemStyle: {
          color: (params) => {
            const colors = [
              "#ef4444",
              "#f59e0b",
              "#22c55e",
              "#3b82f6",
              "#a855f7",
            ];
            return colors[params.dataIndex % colors.length];
          },
          borderRadius: [6, 6, 0, 0],
        },
      },
    ],
  };

  return (
    <div
      className="dashboard-grid"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gridTemplateRows: "repeat(2, auto)",
        gap: "1.5rem",
      }}
    >
      {/* Baris 1, Kolom 1 */}
      <div className="card shadow-sm border" style={{ borderWidth: "3px" }}>
        <div className="card-body">
          <ReactECharts option={optionMonthly} style={{ height: 300 }} />
        </div>
      </div>

      {/* Baris 1, Kolom 2–3 (melebar 2 kolom) */}
      <div className="card shadow-sm border" style={{ borderWidth: "3px" }}>
        <div className="card-body">
          <ReactECharts option={optionNightingale} style={{ height: 300 }} />
        </div>
      </div>

      {/* Kolom 4, memanjang 2 baris */}
      <div
        className="card shadow-sm border"
        style={{
          borderWidth: "3px",
          gridColumn: "4",
          gridRow: "1 / span 2",
        }}
      >
        <div className="card-body">
          <ReactECharts option={optionTopProducts} style={{ height: 640 }} />
        </div>
      </div>

      {/* Baris 2, Kolom 1 */}
      <div className="card shadow-sm border" style={{ borderWidth: "3px" }}>
        <div className="card-body">
          <ReactECharts option={optionStatus} style={{ height: 300 }} />
        </div>
      </div>

      {/* Baris 2, Kolom 2 */}
      <div className="card shadow-sm border" style={{ borderWidth: "3px" }}>
        <div className="card-body">
          <ReactECharts option={optionSource} style={{ height: 300 }} />
        </div>
      </div>

      {/* Baris 2, Kolom 3 */}
      <div
        className="card shadow-sm border"
        style={{
          borderWidth: "3px",
          gridColumn: "2 / span 2",
          gridRow: "1",
        }}
      >
        <div className="card-body">
          <ReactECharts option={optionLineChart} style={{ height: 300 }} />
        </div>
      </div>
    </div>
  );
}
